module.exports = __webpack_public_path__ + "static/media/contactLogo.36c4a682.svg";